import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-funding-source-edit-modal',
  templateUrl: './funding-source-edit-modal.component.html',
  styleUrls: ['./funding-source-edit-modal.component.css']
})
export class FundingSourceEditModalComponent implements OnInit {
  @Input() fundingSource: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveFundingSource(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
